import React, {useEffect, useState} from 'react';
import {Col, Dropdown, Menu, Row, Space, Tooltip} from "antd";
import {MoreOutlined} from "@ant-design/icons";
import {getProcessAssignObject} from "../../../../../../api/workplace/process/work-process/process-config";
import {getActionButtons, onClickRequestButton, onClickTransitionButton} from "./ButtonShiftWork";
import {useNavigate} from "react-router-dom";
import {changeDataButtonProcess} from "../../../../../../redux/actions/layout/data/action";
import {useDispatch} from "react-redux";
import {APP_CODE_SALARY} from "./Constant";

const MenuShiftWork = ({rowKey, moduleCode, appCode, classPk, status,decisionNo,creatorId,data}) => {
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState(false)

    const [transitionButtons, setTransitionButtons] = useState(null)
    const [requestButtons, setRequestButtons] = useState(null)
    const [actionButtons, setActionButtons] = useState([])
    const [hiddenRecall, setHiddenRecall] = useState(false)

    const [inlineButtons, setInlineButtons] = useState(null)
    const [dropdownButtons, setDropdownButtons] = useState(null)
    const dispatch = useDispatch()

    useEffect(() => {
        const node = document.querySelector(`tr[data-row-key=${rowKey}]`)
        const onMouseEnter = () => setVisible(true)
        if(APP_CODE_SALARY !== appCode) {
            const onMouseLeave = () => setVisible(false)
            node?.addEventListener("mouseleave", onMouseLeave)
        }

        node?.addEventListener("mouseenter", onMouseEnter)

        return () => {
            node?.removeEventListener("mouseenter", onMouseEnter)
            if(APP_CODE_SALARY !== appCode) {
                node?.removeEventListener("mouseleave", () => setVisible(false))
            }
        }
    }, [])

    useEffect(() => {

        const timeout = setTimeout(() => {

            if (!!transitionButtons && !!requestButtons && !!actionButtons) {
                const mergeButtons = [ ...transitionButtons,...actionButtons, ...requestButtons]

                if (mergeButtons.length > 3) {
                    setInlineButtons(mergeButtons.slice(0, 2))
                    setDropdownButtons(mergeButtons.slice(2, mergeButtons?.length))
                } else {
                    setInlineButtons(mergeButtons)
                    setDropdownButtons([])
                }
            }
        }, 300)

        return () => clearTimeout(timeout)

    }, [transitionButtons, requestButtons, actionButtons]);

    const loadButton = async () => {
        setLoading(true)
        getProcessAssignObject({moduleCode, appCode, classPk}).then(r => {
            setHiddenRecall(r?.recalled)
            const transitions = r?.transitions || "[]"
            const requests = r?.requests || "[]"
            requests ? setRequestButtons(JSON.parse(requests)?.map(item => ({
                ...item,
                onClick: () => onClickRequestButton({
                    classPk,
                    moduleCode,
                    appCode,
                    name: item.name,
                    approval: item.approval,
                    type: item.type,
                    onAfterSuccess: () => {
                        loadButton()
                        dispatch(changeDataButtonProcess('notification'))
                    },
                    decisionNo,
                })
            }))) : setRequestButtons([])
            transitions ? setTransitionButtons(JSON.parse(transitions)?.map(item => ({
                ...item,
                onClick: () => onClickTransitionButton({
                    classPk,
                    moduleCode,
                    appCode,
                    code: item.code,
                    name: item.name,
                    onAfterSuccess: () => {
                        loadButton()
                        dispatch(changeDataButtonProcess('notification'))
                    },
                    decisionNo,
                })
            }))) : setTransitionButtons([])
        }).catch(() => {
            setTransitionButtons([])
        }).finally(() => {
            setLoading(false)
        })
    }

    useEffect(() => {
        setActionButtons(getActionButtons(data,classPk, status, classPk, moduleCode, appCode
            ,hiddenRecall,
            decisionNo,creatorId , {
            recall: () => {
                setHiddenRecall(true)
            }
        }))
    }, [status, moduleCode, appCode, classPk, decisionNo,hiddenRecall]);

    useEffect(() => {

        const timeout = setTimeout(() => {
            !loading && !!visible && !transitionButtons && loadButton()
        }, 100)

        return () => {
            clearTimeout(timeout)
        }

    }, [visible]);

    return visible && !!transitionButtons && (
        <Space>
            {!!inlineButtons && inlineButtons?.length > 0 && (
                <Row gutter={12} justify={"end"} align={"middle"}>
                    {inlineButtons?.map((item, index) => {

                        return <MenuItem onClick={item.onClick}
                                         name={item.name}
                                         color={item.color}
                                         menuKey={item.code}
                                         icon={item.icon}
                                         key={index}
                                         type={"row"}
                                         redirect={item.redirect}
                        />
                    })}
                </Row>
            )}

            {!!dropdownButtons && dropdownButtons?.length > 0 && (
                <div menu-key={rowKey}>
                    <Dropdown
                        className={"hover:bg-[#f5f5f5] p-1"}
                        dropdownRender={() => <Menu selectable={false}>
                            {dropdownButtons?.map((item, index) => {

                                return <MenuItem onClick={item.onClick}
                                                 name={item.name}
                                                 color={item.color}
                                                 menuKey={item.code}
                                                 key={index}
                                                 redirect={item.redirect}

                                />
                            })}
                        </Menu>}
                        trigger={["click"]}
                        placement="bottomLeft"
                        getPopupContainer={() => APP_CODE_SALARY === appCode ? document.body  : document.querySelector(`div[menu-key=${rowKey}]`)}
                    >
                        <MoreOutlined className="text-[18px] leading-[18px]"/>
                    </Dropdown>
                </div>
            )}
        </Space>
    )
};

export default MenuShiftWork;

const MenuItem = ({name, icon, color, onClick, redirect, type}) => {

        const navigate = useNavigate()

        function onClickItem() {

            onClick && onClick()
            redirect && navigate(redirect)
        }

        return type === "row" ?
            <Col onClick={onClickItem}
                 title={name}
                 className={"hover:bg-[#f5f5f5]"}
            >
                <Tooltip title={name}>
                    {icon
                        ? React.cloneElement(icon, {
                            style: {color: color && color},
                            className: "text-[18px] leading-[18px]"
                        })
                        : <span style={{color: color && color}} className="text-[18px] leading-[18px]">{name[0]}</span>}
                </Tooltip>
            </Col> : <Menu.Item
                key={Math.random()}
                onClick={onClickItem}
                title={name}
                className={"text-left !bg-white hover:!bg-[#f5f5f5]"}
            >
                {name}
            </Menu.Item>
    }
